import React, { useEffect, useState } from 'react';
import MapIcon from '@mui/icons-material/Map';
import ChatIcon from '@mui/icons-material/Chat';
import SearchIcon from '@mui/icons-material/Search';
import { useDispatch, useSelector } from 'react-redux';
import { Badge, Card, Drawer, ToggleButton } from '@mui/material';
import { monitoringSelectors } from 'src/selectors';
import useCollapseDrawer from 'src/hooks/useCollapseDrawer';
import { toggleMonitoringMapStatus } from './../../../redux/slices/ui';
import Chat from 'src/common/Chat/Chat';
import CustomDialog from 'src/common/CustomDialog';
import useChatUnreadMessages from 'src/common/Chat/hooks/useChatUnreadMessages';
import DeviceSearch from 'src/common/DevicesSearch';

const MonitoringNav = () => {
  const isMapOpen = useSelector(monitoringSelectors.isMonitoringMapOpen());
  const { openCollapse, closeCollapse } = useCollapseDrawer();
  const dispatch = useDispatch();
  const [showChat, setShowChat] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const { hasUnreadMessages, clearUnreadMessages } =
    useChatUnreadMessages(showChat);

  return (
    <>
      <ToggleButton
        value="check"
        onChange={() => {
          setShowSearch(!showSearch);
        }}
      >
        <SearchIcon />
      </ToggleButton>
      <ToggleButton
        value="check"
        onChange={() => {
          setShowChat(!showChat);
          clearUnreadMessages();
        }}
      >
        <Badge color="success" variant="dot" invisible={!hasUnreadMessages}>
          <ChatIcon />
        </Badge>
      </ToggleButton>
      <ToggleButton
        value="check"
        selected={isMapOpen}
        onChange={() => {
          dispatch(toggleMonitoringMapStatus());
          if (isMapOpen) closeCollapse();
          else openCollapse();
        }}
      >
        <MapIcon />
      </ToggleButton>
      <CustomDialog
        open={showChat}
        onClose={() => setShowChat(!showChat)}
        maxWidth="lg"
      >
        <Chat />
      </CustomDialog>
      <Drawer
        open={Boolean(showSearch)}
        anchor="right"
        variant="temporary"
        onClose={() => setShowSearch(!showSearch)}
      >
        <DeviceSearch />
      </Drawer>
    </>
  );
};

export default MonitoringNav;
